import { BasicAppliedFilters } from 'app/components/design-system-components/list-filters/BasicAppliedFilters'
import { buildRenderedFilterConfig } from 'app/pages/teams/rental-references/components/SearchAndFilter/filters.config'

export const RRTableAppliedFilters = ({ filters, onDismissFilter }: any) => {
  return (
    <BasicAppliedFilters
      filtersConfig={buildRenderedFilterConfig(filters)}
      onDismissFilter={onDismissFilter}
      enableFilters={undefined}
    />
  )
}
